// extracted by mini-css-extract-plugin
export var actionText = "_ow-4";
export var container = "_ow-0";
export var leftSection = "_ow-1";
export var rightSection = "_ow-2";
export var settingsButton = "_ow-6";
export var settingsIcon = "_ow-7";
export var shortcut = "_ow-5";
export var shortcutGroup = "_ow-3";